// test1040
(1040 && 0);
